import { Form } from 'antd';
import styled from 'styled-components';
import { ChargesFiltersType } from '../Charges/types';

export const StyledFiltersContainer = styled.div`
	display: flex;
	gap: 1rem;
	margin-bottom: 1rem;
	align-items: flex-end;
`;

export const StyledChargesFiltersForm = styled(Form<ChargesFiltersType>)`
	display: flex;
	align-items: center;
	width: 100%;
	gap: 0.7rem;
	flex-wrap: wrap;
`;

export const StyledFiltersFormItem = styled(Form.Item)`
	label {
		font-weight: bold;
		color: ${p => p.theme.text};
	}
`;
